<template>
  <div class="tab_page">
    <div class="tab_ul">
      <div
        v-for="item in arrItems"
        :key="item.value"
        :class="{'tab_item':true, 'act': curActive == item.value}"
        @click="switchTab(item.value)">
        {{item.label}}
      </div>
    </div>
    <div class="page_content" :style="{'min-width': minWidth + 'px'}">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AccountTab',
  props: {
    value: [String, Number],
    arrItems: {
      type: Array,
      default () { return [] }
    },
    minWidth: Number
  },
  computed: {
    curActive: {
      get () { return this.value },
      set (v) { this.$emit('input', v) }
    }
  },
  created () {
    if (!this.value && this.arrItems.length) this.curActive = this.arrItems[0].value
  },
  methods: {
    switchTab (val) {
      if (this.curActive !== val) {
        this.curActive = val
        this.$emit('tabChange', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab_page {
  padding-top: 20px;
  height: 100%;
  .tab_ul {
    margin: 0 20px 0 20px;
    .tab_item {
      cursor: pointer;
      display: inline-block;
      width: 160px;
      height: 40px;
      margin-right: 10px;
      color: #282729;
      font-size: 16px;
      text-align: center;
      line-height: 40px;
      border: 1px solid #E9E9E9;
      border-bottom: none 0;
      box-sizing: border-box;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      &.act {
        font-weight: bold;
        background: $minor-gradient;
        border: none 0;
      }
    }
  }
  .page_content {
    margin: 0 20px;
    padding: 0 0 20px;
    border: 1px solid #E9E9E9;
    height: calc(100% - 40px);
  }
}
</style>